<template>
  <nav class="navbar navbar-dark navbar-expand-lg  fixed-top">
      <div class="container d-flex">
          <router-link class="navbar-brand" :to="{ name: 'home' }"
              ><img height="100%" src="../assets/images/white-logo.svg" alt="logo"
          /></router-link>
          <button
              :class="['navbar-toggler', { collapsed: isNavbarOpen } ]"
              @click="isNavbarOpen = !isNavbarOpen"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNavAltMarkup"
              aria-controls="navbarNavAltMarkup"
              :aria-expanded="isNavbarOpen ? 'true' : 'false'"
              aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div :class="['collapse pb-2 pb-md-0', 'navbar-collapse', { show: isNavbarOpen }]" id="navbarNavAltMarkup">
              <ul class="navbar-nav mx-auto d-flex align-items-center flex-column flex-lg-row my-3">
                  <li class="nav-item mx-0 me-lg-4" @click="isNavbarOpen = false"><router-link class="nav-link text-white" :to="{ name: 'home'}">{{ $t('home') }}</router-link></li>
                  <li class="nav-item me-lg-4" @click="isNavbarOpen = false"><router-link class="nav-link text-white" :to="{ name: 'about'}">{{ $t('about')}}</router-link></li>
                  <li class="nav-item me-lg-4" @click="isNavbarOpen = false"><router-link class="nav-link text-white" :to="{ name: 'products'}">{{ $t('products') }}</router-link></li>
                  <li class="nav-item me-lg-4" @click="isNavbarOpen = false"><router-link class="nav-link text-white" :to="{ name: 'news-index'}">{{$t('articles')}}</router-link></li>
                  <li class="nav-item me-lg-4" @click="isNavbarOpen = false"><router-link class="nav-link text-white" :to="{ name: 'contact-us'}">{{ $t('contact') }}</router-link></li>
              </ul>
              <span class="me-5"><i class="fas fa-search text-white fa-lg"></i></span>
              <button @click="changeLocaleAndReload('en')" :class="{'active': activeLang === 'en' }" class=" flag btn btn-outline-inherit border-0 p-0 ms-2" type="submit"><img src="../assets/images/flag/flag-united-state.png" width="100%" class="img-flag" alt="EN"></button>
              <button @click="changeLocaleAndReload('es')" :class="{'active': activeLang === 'es' }" class=" flag btn btn-outline-inherit border-0 p-0 ms-2" type="submit"><img src="../assets/images/flag/flag-spain.png" width="100%" class="img-flag" alt="ES"></button>
          </div>
      </div>
      <!-- loader -->
      <div v-show="loading" class="container text-center">
        <div class="loading-overlay">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
  </nav>

</template>
<script>
export default {

  name: 'NavBar',
  data () {
    return {
      isNavbarOpen: false,
      activeLang: '',
      loading: false
    }
  },
  methods: {
    changeLocale (locale) {
      this.$i18n.locale = locale
      this.activeLang = locale
      localStorage.setItem('locale', locale)
    },

    reloadPage () {
      this.loading = true

      setTimeout(() => {
        location.reload()
      }, 1000)
    },

    changeLocaleAndReload (locale) {
      this.changeLocale(locale)
      this.reloadPage()
    }
  },

  mounted () {
    const savedLocale = localStorage.getItem('locale')
    if (savedLocale) {
      this.$i18n.locale = savedLocale
      this.activeLang = savedLocale
    }
  }
}

</script>

<style lang="scss">
.navbar {
background: linear-gradient(190deg, #3d769f 10%, #4a7c9f 50%, rgb(80, 123, 164) 90%);
@media(max-width: 992px) {
  text-align: center;
}
.navbar-nav {
  .nav-link {
    border-bottom: solid 2px transparent;
    width: fit-content;
    &:hover {
      border-bottom-color: white;
    }
    &.router-link-exact-active {
      border-bottom-color:white;
    }
  }
}
.flag {
  width: 25px;
}

.active {
  .img-flag {
    filter:
      drop-shadow( 2px  0px 0px #48d0fa)
      drop-shadow(-2px  0px 0px #48d0fa)
      drop-shadow( 0px  2px 0px #48d0fa)
      drop-shadow( 0px -2px 0px #48d0fa);
  }
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(255, 255, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}
}
</style>
